// files.tsx
import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useModal } from '../../components/layout';
import { Alert } from 'react-bootstrap';
import { useProfileManagement } from '../../components/auth/useProfileManagement';
import CombinedFileList from '../../components/data-sources/CombinedFileList.tsx';
import ContentSkeleton from '../../components/loading/ContentSkeleton';

const Files: React.FC = () => {
    const { user, isLoading: authLoading } = useAuth();
    const modalState = useModal();
    const [refreshKey, setRefreshKey] = useState(0);
    const [showDriveSync, setShowDriveSync] = useState(false);

    useProfileManagement(
        undefined,
        modalState.setError,
        modalState.setSuccess,
        modalState.setIsLoading,
        modalState.setShowProfileModal,
        modalState.setShowPasswordModal
    );

    const handleError = (error: string) => {
        modalState.setError(error);
    };

    const handleDriveSync = () => {
        console.log('Drive sync initiated from Files component');
        setShowDriveSync(true);
    };

    const handleDriveSyncSuccess = () => {
        console.log('Drive sync completed successfully');
        setShowDriveSync(false);
        setRefreshKey(prev => prev + 1);
        modalState.setSuccess('Files synced successfully from Google Drive');
    };

    // Content loading state
    if (authLoading) {
        return (
            <>
                <h5 className="mb-3">Files</h5>
                <ContentSkeleton />
            </>
        );
    }

    if (!user) {
        return (
            <div className="container mt-5">
                <Alert variant="warning">Please log in to view files.</Alert>
            </div>
        );
    }

    const isAdmin = user.role === 'admin';

    return (
        <div className="page-container">
            <h5 className="mb-3">Files</h5>
            {modalState.error && (
                <Alert variant="danger" className="mb-3" dismissible onClose={() => modalState.setError(null)}>
                    {modalState.error}
                </Alert>
            )}
            {modalState.success && (
                <Alert variant="success" className="mb-3" dismissible onClose={() => modalState.setSuccess(null)}>
                    {modalState.success}
                </Alert>
            )}

            <CombinedFileList
                key={refreshKey}
                onError={handleError}
                isAdmin={isAdmin}
                refreshKey={refreshKey}
                showDriveSync={showDriveSync}
                onDriveSync={handleDriveSync}
                onDriveSyncSuccess={handleDriveSyncSuccess}
            />
        </div>
    );
};

export default Files;